import React from "react";
import { MathJax } from "better-react-mathjax";
import CorrectSvg from "@Assets/svg/Dashboard-svgs/correct.svg";
import WroungSvg from "@Assets/svg/Dashboard-svgs/Wroung.svg";
import { useTranslation } from "react-i18next";

export const ResultCard = React.memo(({ review, rightOptions, opt, options, missedOption }: any) => {
    const {t}=useTranslation("common");
    return (

        review && review.IsMultiple ?
            <div className={`review-options  ${(missedOption && missedOption.length && missedOption.includes(opt[0].toLowerCase())) ? 'missed-answer' : review.Ans && (review.Ans.toLowerCase().includes(opt[0].toLowerCase())) ? 'correct-question' : (review.SelectedOption && (review.SelectedOption.toLowerCase().includes(opt[0].toLowerCase())) && review.AnsType === 0) ? 'incorrect-qust' :
                ''}
                                            `}>
                <span className="opt-span tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
                    <span className="tw-flex tw-items-start tw-gap-3 tw-flex-1"> 
                        <span className="tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-gray-500 tw-bg-gray-100 tw-rounded-full tw-min-w-[28px] tw-h-[28px] tw-text-xs">
                            {opt[0]}
                        </span>
                        <span className="option-value tw-flex-1 tw-justify-center tw-items-center" style={{ paddingLeft: 0, overflowY: 'hidden' }}>
                            <MathJax dangerouslySetInnerHTML={{ __html: opt[1] }} dynamic={true} >
                            </MathJax>
                        </span>
                    </span>
                    {rightOptions.some((ans: string) => ans.trim().toLowerCase() === opt[0].toLowerCase()) &&
                        !options.some((sel: string) => sel.trim().toLowerCase() === opt[0].toLowerCase()) ? (
                        review.AnsType === 2 ? (
                            <span className="correct-opt-span">{t("correct_answer_is_option")} {opt[0].toUpperCase()} </span>
                        ) : (
                            <span className="missed-opt-span">{t("missed_out_option")} {opt[0].toUpperCase()} </span>
                        )
                    ) : ''}

                    {options.some((sel: string) => sel.trim().toLowerCase() === opt[0].toLowerCase()) ? (
                        rightOptions.some((ans: string) => ans.trim().toLowerCase() === opt[0].toLowerCase()) ? (
                            <img className="Correct-svg" src={CorrectSvg} alt="correct-svg" />
                        ) : (
                            <img src={WroungSvg} className="incorrect-svg" alt="wrong-svg" />
                        )
                    ) : null}
                </span>
            </div>
            :
            <div className={`review-options  ${(review.Ans && (review.Ans.toLowerCase().includes(opt[0].toLowerCase()))) ? 'correct-question' : (review.SelectedOption && (review.SelectedOption.toLowerCase().includes(opt[0].toLowerCase())) && review.AnsType === 0) ? 'incorrect-qust' : ''}
                                            `}>
                <span className="opt-span tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
                    <span className="tw-flex tw-items-start tw-gap-3 tw-flex-1"> 
                        <span className="tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-gray-500 tw-bg-gray-100 tw-rounded-full tw-min-w-[28px] tw-h-[28px] tw-text-xs">
                            {opt[0]}
                        </span>
                        <span className="option-value tw-flex-1 tw-justify-center tw-items-center" style={{ paddingLeft: 0, overflowY: 'hidden' }}>
                            <MathJax dangerouslySetInnerHTML={{ __html: opt[1] }} dynamic={true} >
                            </MathJax>
                        </span>
                    </span>
                    {opt[0].toLowerCase() == rightOptions[0] && review.AnsType != 1 ?
                        <span className="correct-opt-span">{t("correct_answer_is_option")} {review.Ans.toUpperCase()} </span>
                        : ''}
                    {opt[0].toLowerCase() == rightOptions[0] && review.AnsType == 1 ?
                        <img className="Correct-svg" src={CorrectSvg} alt="back-svg" />
                        :
                        <img src={WroungSvg} className="incorrect-svg" alt="back-svg" />
                    }
                    {/* <img src={WroungSvg} className="incorrect-svg" alt="back-svg" /> */}
                </span>
            </div>
    )
});